import React from 'react';
import './threepillars.css';



import eating from '../images/nutritiousmeals.jpg'; 
import learning from '../images/bb_learning.JPEG'; 
import outside from '../images/holistic.jpg'; 

export default function ThreePillars() {
  const pillars = [
    {
      title: 'Quality Education',
      img: learning,
      description:
        'Bright Beginning provides a robust curriculum designed to inspire curiosity, creativity, and a lifelong love of learning. Our dedicated teachers adapt lessons to each student’s needs, ensuring that every child can thrive.',
    },
    {
      title: 'Nutritious Meals',
      img: eating,
      description:
        'We believe a healthy mind starts with a healthy body. Our students enjoy freshly prepared, balanced meals every day, designed to fuel their learning and support overall well-being.',
    },
    {
      title: 'Holistic Enrichment',
      img: outside,
      description:
        'From art and music to dance and field trips, our enrichment programs help students explore their passions, build confidence, and develop skills that extend beyond the classroom.',
    },
  ];

  return (
    <section className="three-pillars">
      <div className="pillar-container">
        {pillars.map((pillar, index) => (
          <div
            className={`pillar-card pillar-${index + 1}`}
            key={index}
          >
            <img src={pillar.img} alt={pillar.title} className="pillar-image" />
            <div className="pillar-content">
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
